import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { PasswordValidationResponse, PasswordValidationLevel } from '@core/models/password.model';
import { PasswordValidationService } from '@core/services/password-validation/password-validation.service';
// import * as strengthCtrl from 'zxcvbn';

@Component({
  selector: 'core-helpers-forms-password-validation',
  templateUrl: './password-validation.component.html',
  styleUrls: ['./password-validation.component.scss'],
})
export class HelperFormPasswordValidationComponent implements OnChanges {
    public readonly PASSWORD_LENGTH_REQUIRED = 14;

    @Input() password: string = "";
    @Input() email: string;
    @Input() checksum: number;
    @Output() valid = new EventEmitter<boolean>();

    public strengthLevel: number;
    public validPassword: boolean; 
    public validity: boolean;


    private token: string;
    constructor(
        private validationSrv: PasswordValidationService,
        private route: ActivatedRoute){
            this.token = this.route.params['value'].hash;
        }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.password && (changes.password.currentValue != '' || (changes.password.previousValue))) {
            this.validatePassword();
        }
    }

    public getStrengthLevelClass() : string {
        switch (this.strengthLevel) {
            case PasswordValidationLevel.STRONG:
                return this.validPassword ? 'ps-strong' : 'ps-medium';
            case PasswordValidationLevel.MEDIUM:
                return 'ps-medium';
            case PasswordValidationLevel.WEAK:
                return this.password != '' ? 'ps-weak' : 'ps-none';
            default:
                return 'ps-none';
            }
    }

    protected onValid() {
        this.validity =  (this.strengthLevel == PasswordValidationLevel.STRONG && this.validPassword) ;

        this.valid.emit(this.validity);
    }

    protected validatePassword() : void {
        this.validationSrv.checkPasswordValidity(this.password, this.checksum ? this.token : '', this.email).subscribe((result:PasswordValidationResponse) => {
            if(result){
                this.strengthLevel = result.level;
                this.validPassword = result.valid;
                this.onValid();
            }
        })
    }


}
